import { TranslationKey } from "types";

export enum TabType {
  Network = "Network",
  Protect = "Protect",
  Integrations = "Integrations",
  MultiSite = "Multisite",
  Organizations = "Organizations",
}

export interface ITourTab {
  label: TranslationKey;
  playbackTimeInSeconds: number;
  id: TabType;
  icon: React.ReactElement;
}

export interface IAnimationConfig {
  desktop: IVideoConfig;
  mobile: IVideoConfig;
  hologram: IVideoConfig;
}

interface IVideoConfig {
  src?: string;
  srcMobile?: string;
  poster: string;
}
